import { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { useUserContext } from '@/contexts/user';

interface ArgSignupIndexRouteProps {
  Component: FC;
}

const IndexRoute: FC<ArgSignupIndexRouteProps> = ({ Component }) => {
  const { isGuest, isWaiting, isSmsWaiting, isVerified } = useUserContext();

  if (!isGuest) {
    if (isSmsWaiting) {
      return <Navigate to="/signup/verify" />;
    }
    if (isWaiting) {
      return <Navigate to="/signup/redirect" />;
    }
    return <Navigate to="/" />;
  }

  if (isVerified) {
    return <Navigate to="/signup/registration" />;
  }

  return <Component />;
};

export default IndexRoute;
